import type { RouteObject } from 'react-router';
import { useSearchParams } from 'react-router';
import { createElement } from 'react';
import { ShowcasePage } from './showcase/ShowcasePage';
import { ProjectWritePage } from './pages/ProjectWritePage';
import { BlogSharePage } from './showcase/BlogSharePage';
import { CasesPage } from './showcase/CasesPage';

/** 시공사례 등록 — 새로 만들기는 AI 시공사례 템플릿 고르기, 예전 블록형 사례 편집(?projectId=)은 기존 편집기 */
function WriteRoute() {
  const [sp] = useSearchParams();
  return createElement(sp.get('projectId') ? ProjectWritePage : ShowcasePage);
}

// 나의 시공사례(조회) · 시공사례 등록(템플릿 고르기) · 편집 화면 · 블로그로 퍼가기
export const routes: RouteObject[] = [
  { path: '/agents/portfolio', Component: CasesPage },
  { path: '/agents/portfolio/projects', Component: CasesPage },
  { path: '/agents/portfolio/showcase/:projectId', Component: ShowcasePage },
  { path: '/agents/portfolio/write', Component: WriteRoute },
  // 블로그로 퍼가기 — 나의 시공사례마다 네이버 블로그용 복사 · 사진 ZIP
  { path: '/agents/portfolio/sns', Component: BlogSharePage },
];
